export enum TaskType {
  // 質問回答
  QUESTION_ANSWER = "QUESTION_ANSWER",
  // オンライン自習室
  SELF_STUDY_ROOM = "SELF_STUDY_ROOM",
}
